import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = [
    'newFileSubmitButton',
    'newFileSubmitButtonDisabled',
    'fileTypeHiddenInput',
    'spinner'
  ]

  declare readonly newFileSubmitButtonTarget: HTMLButtonElement
  declare readonly newFileSubmitButtonDisabledTarget: HTMLButtonElement
  declare readonly fileTypeHiddenInputTarget: HTMLInputElement
  declare readonly hasFileTypeHiddenInputTarget: boolean
  declare readonly spinnerTarget: HTMLElement

  #hasType = false
  #hasFile = false

  #enableSubmitButton(): void {
    this.newFileSubmitButtonDisabledTarget.classList.add('hidden')
    this.newFileSubmitButtonTarget.classList.remove('hidden')
  }

  directUploadsStarted(): void {
    this.newFileSubmitButtonDisabledTarget.classList.remove('hidden')
    this.newFileSubmitButtonTarget.classList.add('hidden')
  }

  directUploadsEnded(): void {
    this.newFileSubmitButtonDisabledTarget.classList.add('hidden')
    this.newFileSubmitButtonTarget.classList.add('hidden')
    this.spinnerTarget.classList.remove('hidden')
  }

  fileChanged(): void {
    if (this.#hasType || this.hasFileTypeHiddenInputTarget) {
      this.#enableSubmitButton()
    }
    this.#hasFile = true
  }

  typeChanged(): void {
    if (this.#hasFile) {
      this.#enableSubmitButton()
    }
    this.#hasType = true
  }
}
